import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Router } from '@angular/router';

import { Store } from '@ngrx/store';
import { AppSelectors } from 'projects/semeris/src/store/app/app.selectors';
import { RootState } from 'projects/semeris/src/store/root-state.model';
import { Observable, of } from 'rxjs';
import { filter, map, switchMap, take } from 'rxjs/operators';

import { isEmbedded } from '../../shared/constants/embedded.regex';
import { SemerisRoutes } from '../../shared/constants/routes';
import { UserProfileService } from '../../settings/services/user-profile.service';

@Injectable({ providedIn: 'root' })
export class AssetGuard implements CanActivate {
  private readonly store = inject<Store<RootState>>(Store);
  private readonly userProfileService = inject(UserProfileService);
  private readonly router = inject(Router);

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | boolean {
    return (
      isEmbedded() ||
      this.userProfileService.getProfile().pipe(
        switchMap((user) => {
          if (user.blocked) {
            return of(this.router.createUrlTree(['/', SemerisRoutes.blocked]));
          }

          return this.store.select(AppSelectors.assets).pipe(
            filter((assets) => !!assets),
            take(1),
            map((assets) => {
              const hasAccess = !!assets?.length;

              if (!hasAccess) {
                console.log('No access to assets');
                return this.router.createUrlTree(['/', SemerisRoutes.welcome]);
              }

              return true;
            })
          );
        })
      )
    );
  }
}
